'use client';

import { FaqSection as KeziosFaqSection } from '@kezios/design-system';
import { Flex } from '@mantine/core';
import { useTranslations } from 'next-intl';

export const CompanySection = () => {
  const t = useTranslations('section.company');

  return (
    <Flex w="100%" h="100%" justify={'center'} align={'center'}>
      <a
        href="https://calendar.app.google/hviEgDuexnGn9a6f6"
        target="_blank"
        rel="noreferrer"
        style={{ color: '#EB5B26', textDecoration: 'underline' }}
      >
        {t('book')}
      </a>
    </Flex>
  );
};
